export var AmenityEnum;
(function (AmenityEnum) {
    // These are impossibly fast search amenities
    AmenityEnum["AccessibleBathroom"] = "AccessibleBathroom";
    AmenityEnum["AdultsOnly"] = "AdultsOnly";
    AmenityEnum["AirportTransportationAvailableGeneral"] = "AirportTransportationAvailableGeneral";
    AmenityEnum["AtmBanking"] = "AtmBanking";
    AmenityEnum["BarOrLounge"] = "BarOrLounge";
    AmenityEnum["BrailleOrRaisedSignage"] = "BrailleOrRaisedSignage";
    AmenityEnum["BusinessCenter"] = "BusinessCenter";
    AmenityEnum["Casino"] = "Casino";
    AmenityEnum["ComputerStation"] = "ComputerStation";
    AmenityEnum["ConciergeServices"] = "ConciergeServices";
    AmenityEnum["ConferenceSpace"] = "ConferenceSpace";
    AmenityEnum["DryCleaningLaundryService"] = "DryCleaningLaundryService";
    AmenityEnum["ElectricCarCharging"] = "ElectricCarCharging";
    AmenityEnum["ExpressCheckIn"] = "ExpressCheckIn";
    AmenityEnum["FitnessFacilities"] = "FitnessFacilities";
    AmenityEnum["FreeAirportTransportation"] = "FreeAirportTransportation";
    AmenityEnum["FreeBreakfast"] = "FreeBreakfast";
    AmenityEnum["FreeSelfParking"] = "FreeSelfParking";
    AmenityEnum["FreeWifi"] = "FreeWifi";
    AmenityEnum["FullServiceSpa"] = "FullServiceSpa";
    AmenityEnum["Garden"] = "Garden";
    AmenityEnum["HairSalon"] = "HairSalon";
    AmenityEnum["HikingOrBikingNearby"] = "HikingOrBikingNearby";
    AmenityEnum["IndoorPool"] = "IndoorPool";
    AmenityEnum["InRoomAccessibility"] = "InRoomAccessibility";
    AmenityEnum["LaundryFacilities"] = "LaundryFacilities";
    AmenityEnum["LuggageStorage"] = "LuggageStorage";
    AmenityEnum["MeetingRooms"] = "MeetingRooms";
    AmenityEnum["NumberOfBarsOrLounges"] = "NumberOfBarsOrLounges";
    AmenityEnum["NumberOfRestaurants"] = "NumberOfRestaurants";
    AmenityEnum["OutdoorPool"] = "OutdoorPool";
    AmenityEnum["OutdoorSeasonalPool"] = "OutdoorSeasonalPool";
    AmenityEnum["PaidBreakfast"] = "PaidBreakfast";
    AmenityEnum["PaidSelfParking"] = "PaidSelfParking";
    AmenityEnum["PaidValetParking"] = "PaidValetParking";
    AmenityEnum["ParkingAvailableGeneral"] = "ParkingAvailableGeneral";
    AmenityEnum["PetsAllowed"] = "PetsAllowed";
    AmenityEnum["PetsAllowedNoFees"] = "PetsAllowedNoFees";
    AmenityEnum["PetsOnlyCats"] = "PetsOnlyCats";
    AmenityEnum["PetsOnlyDogs"] = "PetsOnlyDogs";
    AmenityEnum["PetsOnlyDogsAndCats"] = "PetsOnlyDogsAndCats";
    AmenityEnum["PoolGeneral"] = "PoolGeneral";
    AmenityEnum["PoolsideBar"] = "PoolsideBar";
    AmenityEnum["PorterBellhop"] = "PorterBellhop";
    AmenityEnum["Restaurant"] = "Restaurant";
    AmenityEnum["RollInShower"] = "RollInShower";
    AmenityEnum["SafeDepositBoxFrontDesk"] = "SafeDepositBoxFrontDesk";
    AmenityEnum["Sauna"] = "Sauna";
    AmenityEnum["SnackOrDeli"] = "SnackOrDeli";
    AmenityEnum["SomeAccessibilityFeaturesAvailableGeneral"] = "SomeAccessibilityFeaturesAvailableGeneral";
    AmenityEnum["SpaTreatmentRoom"] = "SpaTreatmentRoom";
    AmenityEnum["SteamRoom"] = "SteamRoom";
    AmenityEnum["SwimmingPool"] = "SwimmingPool";
    AmenityEnum["Terrace"] = "Terrace";
    AmenityEnum["ToursTicketAssistance"] = "ToursTicketAssistance";
    AmenityEnum["TwentyFourHourFitnessFacilities"] = "TwentyFourHourFitnessFacilities";
    AmenityEnum["TwentyFourHourFrontDesk"] = "TwentyFourHourFrontDesk";
    AmenityEnum["WheelchairAccessibleParking"] = "WheelchairAccessibleParking";
    AmenityEnum["WheelchairAccessiblePathOfTravel"] = "WheelchairAccessiblePathOfTravel";
})(AmenityEnum || (AmenityEnum = {}));
export var LodgingCollectionEnum;
(function (LodgingCollectionEnum) {
    LodgingCollectionEnum["Premier"] = "Premier";
    LodgingCollectionEnum["Lifestyle"] = "Lifestyle";
    LodgingCollectionEnum["NoCollection"] = "NoCollection";
})(LodgingCollectionEnum || (LodgingCollectionEnum = {}));
export var AvailabilityRequestEnum;
(function (AvailabilityRequestEnum) {
    AvailabilityRequestEnum["FollowUpSearch"] = "FollowUpSearch";
    AvailabilityRequestEnum["InitialSearch"] = "InitialSearch";
})(AvailabilityRequestEnum || (AvailabilityRequestEnum = {}));
export var AvailabilityResponseEnum;
(function (AvailabilityResponseEnum) {
    AvailabilityResponseEnum["Initial"] = "Initial";
    AvailabilityResponseEnum["More"] = "More";
})(AvailabilityResponseEnum || (AvailabilityResponseEnum = {}));
export var CategoryEnum;
(function (CategoryEnum) {
    CategoryEnum["Dining"] = "Dining";
    CategoryEnum["Exterior"] = "Exterior";
    CategoryEnum["PointOfInterest"] = "PointOfInterest";
    CategoryEnum["Pool"] = "Pool";
    CategoryEnum["View"] = "View";
    CategoryEnum["Fitness"] = "Fitness";
    CategoryEnum["Lobby"] = "Lobby";
    CategoryEnum["Interior"] = "Interior";
    CategoryEnum["Uncategorized"] = "Uncategorized";
    CategoryEnum["GuestRoom"] = "GuestRoom";
    CategoryEnum["Spa"] = "Spa";
    CategoryEnum["Amenity"] = "Amenity";
    CategoryEnum["Bar"] = "Bar";
    CategoryEnum["Primary"] = "Primary";
    CategoryEnum["SportsFacility"] = "SportsFacility";
})(CategoryEnum || (CategoryEnum = {}));
export var HotelStarRatingEnum;
(function (HotelStarRatingEnum) {
    HotelStarRatingEnum["NotAvailable"] = "NotAvailable";
    HotelStarRatingEnum["Three"] = "Three";
    HotelStarRatingEnum["One"] = "One";
    HotelStarRatingEnum["Two"] = "Two";
    HotelStarRatingEnum["Five"] = "Five";
    HotelStarRatingEnum["Four"] = "Four";
})(HotelStarRatingEnum || (HotelStarRatingEnum = {}));
export var HotelDetailsResponseEnum;
(function (HotelDetailsResponseEnum) {
    HotelDetailsResponseEnum["Success"] = "Success";
    HotelDetailsResponseEnum["Failure"] = "Failure";
})(HotelDetailsResponseEnum || (HotelDetailsResponseEnum = {}));
export var StayType;
(function (StayType) {
    StayType["Hotels"] = "Hotels";
    StayType["Homes"] = "Homes";
})(StayType || (StayType = {}));
export var LodgingPromotionType;
(function (LodgingPromotionType) {
    LodgingPromotionType["DealOfTheDay"] = "DealOfTheDay";
    LodgingPromotionType["Generic"] = "Generic";
})(LodgingPromotionType || (LodgingPromotionType = {}));
export var LodgingAddressEnum;
(function (LodgingAddressEnum) {
    LodgingAddressEnum["Exact"] = "Exact";
    LodgingAddressEnum["Obfuscated"] = "Obfuscated";
})(LodgingAddressEnum || (LodgingAddressEnum = {}));
export var LodgingLocationEnum;
(function (LodgingLocationEnum) {
    LodgingLocationEnum["Approximate"] = "Approximate";
    LodgingLocationEnum["Exact"] = "Exact";
})(LodgingLocationEnum || (LodgingLocationEnum = {}));
export var LodgingMediaAssetEnum;
(function (LodgingMediaAssetEnum) {
    LodgingMediaAssetEnum["NonResizableImage"] = "NonResizableImage";
    LodgingMediaAssetEnum["ResizableImage"] = "ResizableImage";
    LodgingMediaAssetEnum["Video"] = "Video";
})(LodgingMediaAssetEnum || (LodgingMediaAssetEnum = {}));
export var LodgingPriceBreakdownEnum;
(function (LodgingPriceBreakdownEnum) {
    LodgingPriceBreakdownEnum["CategorySummary"] = "CategorySummary";
    LodgingPriceBreakdownEnum["LineItemBreakdown"] = "LineItemBreakdown";
    LodgingPriceBreakdownEnum["TotalSummary"] = "TotalSummary";
})(LodgingPriceBreakdownEnum || (LodgingPriceBreakdownEnum = {}));
export var LodgingSelectionEnum;
(function (LodgingSelectionEnum) {
    LodgingSelectionEnum["Location"] = "Location";
    LodgingSelectionEnum["LodgingIds"] = "LodgingIds";
    LodgingSelectionEnum["Market"] = "Market";
    LodgingSelectionEnum["Place"] = "Place";
})(LodgingSelectionEnum || (LodgingSelectionEnum = {}));
export var MealPlanKindEnum;
(function (MealPlanKindEnum) {
    MealPlanKindEnum["AllInclusive"] = "AllInclusive";
    MealPlanKindEnum["Breakfast"] = "Breakfast";
    MealPlanKindEnum["BreakfastFor1"] = "BreakfastFor1";
    MealPlanKindEnum["BreakfastFor2"] = "BreakfastFor2";
    MealPlanKindEnum["Dinner"] = "Dinner";
    MealPlanKindEnum["FullBoard"] = "FullBoard";
    MealPlanKindEnum["HalfBoard"] = "HalfBoard";
    MealPlanKindEnum["Lunch"] = "Lunch";
    MealPlanKindEnum["RoomOnly"] = "RoomOnly";
})(MealPlanKindEnum || (MealPlanKindEnum = {}));
export var PlaceTypeEnum;
(function (PlaceTypeEnum) {
    PlaceTypeEnum["Lodging"] = "Lodging";
})(PlaceTypeEnum || (PlaceTypeEnum = {}));
export var PlatformEnum;
(function (PlatformEnum) {
    PlatformEnum["Desktop"] = "Desktop";
    PlatformEnum["Mobile"] = "Mobile";
    PlatformEnum["App"] = "App";
})(PlatformEnum || (PlatformEnum = {}));
export var WatchGroupingKeyEnum;
(function (WatchGroupingKeyEnum) {
    WatchGroupingKeyEnum[WatchGroupingKeyEnum["MarketGroupingKey"] = 0] = "MarketGroupingKey";
})(WatchGroupingKeyEnum || (WatchGroupingKeyEnum = {}));
export var ShopResponseEnum;
(function (ShopResponseEnum) {
    ShopResponseEnum["Available"] = "Available";
    ShopResponseEnum["Failure"] = "Failure";
    ShopResponseEnum["Unavailable"] = "Unavailable";
})(ShopResponseEnum || (ShopResponseEnum = {}));
export var CancellationReason;
(function (CancellationReason) {
    CancellationReason["CaliforniaBill644"] = "CaliforniaBill644";
})(CancellationReason || (CancellationReason = {}));
export var BedTypeEnum;
(function (BedTypeEnum) {
    BedTypeEnum["Murphy"] = "Murphy";
    BedTypeEnum["Single"] = "Single";
    BedTypeEnum["RunOfTheHouse"] = "RunOfTheHouse";
    BedTypeEnum["Double"] = "Double";
    BedTypeEnum["King"] = "King";
    BedTypeEnum["Dorm"] = "Dorm";
    BedTypeEnum["Twin"] = "Twin";
    BedTypeEnum["Water"] = "Water";
    BedTypeEnum["Queen"] = "Queen";
    BedTypeEnum["Sofa"] = "Sofa";
    BedTypeEnum["Full"] = "Full";
    BedTypeEnum["Tatami"] = "Tatami";
    BedTypeEnum["Futon"] = "Futon";
})(BedTypeEnum || (BedTypeEnum = {}));
export var PriceChangeDirectionEnum;
(function (PriceChangeDirectionEnum) {
    PriceChangeDirectionEnum["Decrease"] = "Decrease";
    PriceChangeDirectionEnum["Increase"] = "Increase";
})(PriceChangeDirectionEnum || (PriceChangeDirectionEnum = {}));
export var RoomTypeEnum;
(function (RoomTypeEnum) {
    RoomTypeEnum["Bedroom"] = "Bedroom";
    RoomTypeEnum["CommonArea"] = "CommonArea";
    RoomTypeEnum["LivingRoom"] = "LivingRoom";
    RoomTypeEnum["Loft"] = "Loft";
})(RoomTypeEnum || (RoomTypeEnum = {}));
export var EffectiveRangeEnum;
(function (EffectiveRangeEnum) {
    EffectiveRangeEnum["Available"] = "Available";
    EffectiveRangeEnum["NotAvailable"] = "NotAvailable";
})(EffectiveRangeEnum || (EffectiveRangeEnum = {}));
export var HotelCancellationPolicyV2Enum;
(function (HotelCancellationPolicyV2Enum) {
    HotelCancellationPolicyV2Enum["FullyRefundable"] = "FullyRefundable";
    HotelCancellationPolicyV2Enum["NonRefundable"] = "NonRefundable";
    HotelCancellationPolicyV2Enum["PartiallyRefundable"] = "PartiallyRefundable";
    HotelCancellationPolicyV2Enum["Unknown"] = "Unknown";
})(HotelCancellationPolicyV2Enum || (HotelCancellationPolicyV2Enum = {}));
export var RoomPaymentSchedule;
(function (RoomPaymentSchedule) {
    RoomPaymentSchedule["PayNow"] = "PayNow";
    RoomPaymentSchedule["PayLater"] = "PayLater";
})(RoomPaymentSchedule || (RoomPaymentSchedule = {}));
export var RoomProductType;
(function (RoomProductType) {
    RoomProductType[RoomProductType["Default"] = 0] = "Default";
    RoomProductType[RoomProductType["RefundableRoom"] = 1] = "RefundableRoom";
})(RoomProductType || (RoomProductType = {}));
/*
  If there is a non-refundable and partially refundable option by the hotel the user will see
  a “Fully refundable by Capital One Travel until {X date}” refundable room; it will be built
  off the hotel’s partially refundable rate.

  for more details, see https://hopchat.slack.com/archives/C02LKB2MVFY/p1688747419628689
*/
export var CancellationPolicyScenarioEnum;
(function (CancellationPolicyScenarioEnum) {
    CancellationPolicyScenarioEnum[CancellationPolicyScenarioEnum["TwoHotelOptionsOneNonRefOnePartiallyRef"] = 0] = "TwoHotelOptionsOneNonRefOnePartiallyRef";
    CancellationPolicyScenarioEnum[CancellationPolicyScenarioEnum["Other"] = 1] = "Other";
})(CancellationPolicyScenarioEnum || (CancellationPolicyScenarioEnum = {}));
export var SupplierRateCategoryEnum;
(function (SupplierRateCategoryEnum) {
    SupplierRateCategoryEnum["Hotelbeds_Regular"] = "Hotelbeds_Regular";
    SupplierRateCategoryEnum["Priceline_Flexible"] = "Priceline_Flexible";
    SupplierRateCategoryEnum["Priceline_Public"] = "Priceline_Public";
    SupplierRateCategoryEnum["Getaroom_ClosedUserGroup"] = "Getaroom_ClosedUserGroup";
    SupplierRateCategoryEnum["Priceline_Private"] = "Priceline_Private";
    SupplierRateCategoryEnum["Priceline_Agoda"] = "Priceline_Agoda";
    SupplierRateCategoryEnum["Booking_LastMinuteDeal"] = "Booking_LastMinuteDeal";
    SupplierRateCategoryEnum["Olympiaeu_Public"] = "Olympiaeu_Public";
    SupplierRateCategoryEnum["Bookohotel_Unknown"] = "Bookohotel_Unknown";
    SupplierRateCategoryEnum["Roomer_net_special_deal"] = "Roomer_net_special_deal";
    SupplierRateCategoryEnum["Booking_SalesCampaign"] = "Booking_SalesCampaign";
    SupplierRateCategoryEnum["Budapest_Private"] = "Budapest_Private";
    SupplierRateCategoryEnum["Getaroom_Tonight"] = "Getaroom_Tonight";
    SupplierRateCategoryEnum["Roomer_net"] = "Roomer_net";
    SupplierRateCategoryEnum["Booking_Mobile"] = "Booking_Mobile";
    SupplierRateCategoryEnum["Agoda_Unknown"] = "Agoda_Unknown";
    SupplierRateCategoryEnum["Hotelbeds_Select"] = "Hotelbeds_Select";
    SupplierRateCategoryEnum["Scrape_Undetermined"] = "Scrape_Undetermined";
    SupplierRateCategoryEnum["HotelPlanner_unpubLight"] = "HotelPlanner_unpubLight";
    SupplierRateCategoryEnum["Scrape_Agoda"] = "Scrape_Agoda";
    SupplierRateCategoryEnum["Expedia_ClosedUserGroup"] = "Expedia_ClosedUserGroup";
    SupplierRateCategoryEnum["Priceline_MemberDeal"] = "Priceline_MemberDeal";
    SupplierRateCategoryEnum["Snaptravel_Public"] = "Snaptravel_Public";
    SupplierRateCategoryEnum["Priceline_ClosedUserGroup"] = "Priceline_ClosedUserGroup";
    SupplierRateCategoryEnum["Roomer_minprice_special_deal"] = "Roomer_minprice_special_deal";
    SupplierRateCategoryEnum["Booking_SecretDeal"] = "Booking_SecretDeal";
    SupplierRateCategoryEnum["Scrape_Expedia"] = "Scrape_Expedia";
    SupplierRateCategoryEnum["Getaroom_Net_Public"] = "Getaroom_Net_Public";
    SupplierRateCategoryEnum["Vrbo_PublicMobile"] = "Vrbo_PublicMobile";
    SupplierRateCategoryEnum["Getaroom_Net_Mobile"] = "Getaroom_Net_Mobile";
    SupplierRateCategoryEnum["Budapest_FencedEverWatchedBookedFlight"] = "Budapest_FencedEverWatchedBookedFlight";
    SupplierRateCategoryEnum["Getaroom_Mobile"] = "Getaroom_Mobile";
    SupplierRateCategoryEnum["Expedia_PublicMobile"] = "Expedia_PublicMobile";
    SupplierRateCategoryEnum["HotelPlanner_packageStrict"] = "HotelPlanner_packageStrict";
    SupplierRateCategoryEnum["Priceline_ClosedUserGroup2"] = "Priceline_ClosedUserGroup2";
    SupplierRateCategoryEnum["HotelPlanner_unpubStrict"] = "HotelPlanner_unpubStrict";
    SupplierRateCategoryEnum["Scrape_Booking"] = "Scrape_Booking";
    SupplierRateCategoryEnum["Priceline_AdditionalRetail"] = "Priceline_AdditionalRetail";
    SupplierRateCategoryEnum["Getaroom_Public"] = "Getaroom_Public";
    SupplierRateCategoryEnum["Priceline_Flexbenchmark"] = "Priceline_Flexbenchmark";
    SupplierRateCategoryEnum["HotelPlanner_packageReg"] = "HotelPlanner_packageReg";
    SupplierRateCategoryEnum["Expedia_PublicWeb"] = "Expedia_PublicWeb";
    SupplierRateCategoryEnum["Hotelbeds_Unknown"] = "Hotelbeds_Unknown";
    SupplierRateCategoryEnum["Priceline_Booking"] = "Priceline_Booking";
    SupplierRateCategoryEnum["Booking_Public"] = "Booking_Public";
    SupplierRateCategoryEnum["Scrape_Getaroom"] = "Scrape_Getaroom";
    SupplierRateCategoryEnum["Roomer_minprice"] = "Roomer_minprice";
    SupplierRateCategoryEnum["Priceline_MobileExclusive"] = "Priceline_MobileExclusive";
    SupplierRateCategoryEnum["Hotelbeds_Special"] = "Hotelbeds_Special";
    SupplierRateCategoryEnum["Scrape_Snaptravel"] = "Scrape_Snaptravel";
    SupplierRateCategoryEnum["Snaptravel_Restricted"] = "Snaptravel_Restricted";
    SupplierRateCategoryEnum["HotelPlanner_unpubReg"] = "HotelPlanner_unpubReg";
    SupplierRateCategoryEnum["Getaroom_Net_Tonight"] = "Getaroom_Net_Tonight";
    SupplierRateCategoryEnum["Dhisco_Net"] = "Dhisco_Net";
    SupplierRateCategoryEnum["Booking_Unknown"] = "Booking_Unknown";
    SupplierRateCategoryEnum["HotelPlanner_unpubMobile"] = "HotelPlanner_unpubMobile";
    SupplierRateCategoryEnum["Expedia_ExposedPackage"] = "Expedia_ExposedPackage";
    SupplierRateCategoryEnum["Budapest_Public"] = "Budapest_Public";
    SupplierRateCategoryEnum["Booking_SmartDeal"] = "Booking_SmartDeal";
    SupplierRateCategoryEnum["Dhisco_Commission"] = "Dhisco_Commission";
    SupplierRateCategoryEnum["Hotelbeds_Offer"] = "Hotelbeds_Offer";
    SupplierRateCategoryEnum["HotelPlanner_Public"] = "HotelPlanner_Public";
    SupplierRateCategoryEnum["Booking_FlashDeal"] = "Booking_FlashDeal";
    SupplierRateCategoryEnum["Hotelbeds_Package"] = "Hotelbeds_Package";
    SupplierRateCategoryEnum["Scrape_Hotelbeds"] = "Scrape_Hotelbeds";
    SupplierRateCategoryEnum["Booking_DealOfTheDay"] = "Booking_DealOfTheDay";
    SupplierRateCategoryEnum["W2m_Public"] = "W2m_Public";
    SupplierRateCategoryEnum["Scrape_Priceline"] = "Scrape_Priceline";
    SupplierRateCategoryEnum["Getaroom_Net_ClosedUserGroup"] = "Getaroom_Net_ClosedUserGroup";
    SupplierRateCategoryEnum["Scrape_Hotelplanner"] = "Scrape_Hotelplanner";
})(SupplierRateCategoryEnum || (SupplierRateCategoryEnum = {}));
export var CancellationPolicyEnum;
(function (CancellationPolicyEnum) {
    CancellationPolicyEnum["Cfar"] = "Cfar";
    CancellationPolicyEnum["NonRefundable"] = "NonRefundable";
    CancellationPolicyEnum["Refundable"] = "Refundable";
    CancellationPolicyEnum["FullRefundable"] = "FullyRefundable";
})(CancellationPolicyEnum || (CancellationPolicyEnum = {}));
export var IconTypeEnum;
(function (IconTypeEnum) {
    IconTypeEnum["Expiration"] = "Expiration";
    IconTypeEnum["Unavailable"] = "Unavailable";
    IconTypeEnum["Info"] = "Info";
    IconTypeEnum["Money"] = "Money";
    IconTypeEnum["Check"] = "Check";
})(IconTypeEnum || (IconTypeEnum = {}));
export var CheckInTimeEnum;
(function (CheckInTimeEnum) {
    CheckInTimeEnum["Anytime"] = "Anytime";
    CheckInTimeEnum["Restricted"] = "Restricted";
})(CheckInTimeEnum || (CheckInTimeEnum = {}));
export var SeverityEnum;
(function (SeverityEnum) {
    SeverityEnum["Fatal"] = "Fatal";
    SeverityEnum["Warning"] = "Warning";
})(SeverityEnum || (SeverityEnum = {}));
export var SlimPaymentEnum;
(function (SlimPaymentEnum) {
    SlimPaymentEnum["SlimCreditCard"] = "SlimCreditCard";
})(SlimPaymentEnum || (SlimPaymentEnum = {}));
export var HotelBookErrorType;
(function (HotelBookErrorType) {
    HotelBookErrorType["NoAvailability"] = "NoAvailability";
    HotelBookErrorType["Unknown"] = "Unknown";
    HotelBookErrorType["CheckInMinimumAgeNotMet"] = "CheckInMinimumAgeNotMet";
    HotelBookErrorType["PaymentError"] = "PaymentError";
    HotelBookErrorType["LackOfInventory"] = "LackOfInventory";
    HotelBookErrorType["RateNotAvailable"] = "RateNotAvailable";
    HotelBookErrorType["Inactivity"] = "Inactivity";
    HotelBookErrorType["RedemptionFailure"] = "RedemptionFailure";
    HotelBookErrorType["RateSoldOut"] = "RateSoldOut";
    HotelBookErrorType["RoomSoldOut"] = "RoomSoldOut";
    HotelBookErrorType["RateChanged"] = "RateChanged";
    HotelBookErrorType["ProviderPaymentError"] = "ProviderPaymentError";
})(HotelBookErrorType || (HotelBookErrorType = {}));
export var HotelBookPollGetResultEnum;
(function (HotelBookPollGetResultEnum) {
    HotelBookPollGetResultEnum["Success"] = "Success";
    HotelBookPollGetResultEnum["Pending"] = "Pending";
    HotelBookPollGetResultEnum["Failed"] = "Failed";
})(HotelBookPollGetResultEnum || (HotelBookPollGetResultEnum = {}));
export var SessionRequestEnum;
(function (SessionRequestEnum) {
    SessionRequestEnum["Open"] = "Open";
    SessionRequestEnum["Close"] = "Close";
})(SessionRequestEnum || (SessionRequestEnum = {}));
export var SessionResponseEnum;
(function (SessionResponseEnum) {
    SessionResponseEnum["Open"] = "Open";
    SessionResponseEnum["Close"] = "Close";
})(SessionResponseEnum || (SessionResponseEnum = {}));
export var CodeEnum;
(function (CodeEnum) {
    CodeEnum["ExcessiveActivity"] = "ExcessiveActivity";
    CodeEnum["Unauthorized"] = "Unauthorized";
})(CodeEnum || (CodeEnum = {}));
export var HotelEntryTypeEnum;
(function (HotelEntryTypeEnum) {
    HotelEntryTypeEnum["CROSS_SELL"] = "cross_sell";
    HotelEntryTypeEnum["FLIGHT_CONFIRMATION_VIEW_ALL"] = "cross_sell_flights_confirmation_viewall";
    HotelEntryTypeEnum["FLIGHT_CONFIRMATION_CARD"] = "cross_sell_flights_confirmation_card";
    HotelEntryTypeEnum["MY_TRIPS_VIEW_ALL"] = "cross_sell_hotel_mytrips_viewall";
    HotelEntryTypeEnum["MY_TRIPS_CARD"] = "cross_sell_hotel_mytrips_card";
    HotelEntryTypeEnum["HOMEPAGE_VIEW_ALL"] = "cross_sell_hotel_homepage_viewall";
    HotelEntryTypeEnum["HOMEPAGE_CARD"] = "cross_sell_hotel_homepage_card";
    HotelEntryTypeEnum["SEARCH_DISTANCE_FROM"] = "search_distance_from";
    HotelEntryTypeEnum["RECENTLY_VIEWED_HOTEL"] = "recently_viewed_hotel";
    HotelEntryTypeEnum["RECENTLY_SEARCHED_HOTEL"] = "recently_searched_hotel";
    HotelEntryTypeEnum["RECENTLY_SEARCH_AUTOCOMPLETE"] = "recently_searched_autocomplete";
    HotelEntryTypeEnum["TRAVEL_SALE_LANDING"] = "travel_sale_landing";
    HotelEntryTypeEnum["TRAVEL_SALE_HOMEPAGE"] = "travel_sale_homepage";
    HotelEntryTypeEnum["BOOK_AGAIN_MY_TRIPS"] = "book_again_hotel_mytrips";
    HotelEntryTypeEnum["BOOK_AGAIN_CONFIRMATION"] = "book_again_hotel_confirmation_page";
})(HotelEntryTypeEnum || (HotelEntryTypeEnum = {}));
export var TabViewEnum;
(function (TabViewEnum) {
    TabViewEnum["VACATION_RENTAL"] = "vacation_rental";
    TabViewEnum["HOTEL"] = "hotel";
    TabViewEnum["ALL_STAYS"] = "all_stays";
})(TabViewEnum || (TabViewEnum = {}));
export var HotelDetailsEntrySourceEnum;
(function (HotelDetailsEntrySourceEnum) {
    HotelDetailsEntrySourceEnum["MAP"] = "map";
    HotelDetailsEntrySourceEnum["LIST"] = "list";
    HotelDetailsEntrySourceEnum["FAVORITES_MAP"] = "favorites_map";
    HotelDetailsEntrySourceEnum["FAVORITES_LIST"] = "favorites_list";
})(HotelDetailsEntrySourceEnum || (HotelDetailsEntrySourceEnum = {}));
export var LodgingAvailabilityCheckInTimeEnum;
(function (LodgingAvailabilityCheckInTimeEnum) {
    LodgingAvailabilityCheckInTimeEnum["Anytime"] = "Anytime";
    LodgingAvailabilityCheckInTimeEnum["Restricted"] = "Restricted";
})(LodgingAvailabilityCheckInTimeEnum || (LodgingAvailabilityCheckInTimeEnum = {}));
export var HotelConfirmationCodeEnum;
(function (HotelConfirmationCodeEnum) {
    HotelConfirmationCodeEnum["HotelConfirmationConfirmed"] = "HotelConfirmationConfirmed";
    HotelConfirmationCodeEnum["HotelConfirmationPending"] = "HotelConfirmationPending";
    HotelConfirmationCodeEnum["HotelConfirmationUnavailable"] = "HotelConfirmationUnavailable";
})(HotelConfirmationCodeEnum || (HotelConfirmationCodeEnum = {}));
//# sourceMappingURL=interfaces.js.map